import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { CreditCardValidators, CreditCard } from 'angular-cc-library';
import { CreditCardHelper } from '../../helpers/creditcard';
import { GlobalServices } from 'app/services/global.service';
import { MemberTypes } from 'app/models/ss-api/responses/login.response';
import { CreditCardResponse, CreditCardTypes } from 'app/models/ss-api/responses/credit.card.response';
import { AddCreditCardRequest } from 'app/models/ss-api/requests/add.credit.card.request';
import { ssApiService } from 'app/services/ss-api.service';
// import * as $ from 'jquery';

// window['jQuery'] = $;

function CustomCreditCardValidator(c: UntypedFormControl) {

  let cardType = CreditCardHelper.GetCardTypes(c.value);

  if (cardType == CreditCardTypes.Unknown || cardType == null) {
    return {
      CustomCreditCardValidator: {
        valid: false
      }
    }
  } else {
    return null;
  }
}

@Component({
  selector: 'ss-cc-form-new',
  templateUrl: './ss-cc-form-new.component.html',
  styleUrls: ['./ss-cc-form-new.component.scss']
})
export class SSCreditCardFormNewComponent implements OnInit {
  @Input() creditCard: CreditCardResponse;
  @Input() isBackup: boolean;

  @ViewChild('ccNumber') ccNumber: ElementRef;

  form: UntypedFormGroup;

  @Output('onFormChanged') onFormChanged: EventEmitter<any>;
  @Output() emitClose: EventEmitter<any> = new EventEmitter();

  ccardForm: UntypedFormGroup;
  ccardType: number;
    

  isMember: boolean;

  Year: number = new Date().getFullYear();
  YearRange: any[] = [];
  SelectedYear;
  IsBusy: boolean;

  constructor(
    private _fb: UntypedFormBuilder,
    private gb: GlobalServices,
    private api: ssApiService,
  ) { }

  ngOnInit() {
    // if (this.creditCard) {
    this.form = this._fb.group({
      creditCard: new UntypedFormControl('', [<any>CreditCardValidators.validateCCNumber, CustomCreditCardValidator]),
      expMonth: [this.gb.ThisMonth(), [Validators.required]],
      expYear: [new Date().getFullYear(), [Validators.required]],
      cvc: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(4)]],
      firstName: ['', [<any>Validators.required]],
      lastName: ['', [<any>Validators.required]],
      zipCode: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(10)]],
      setAsDefault: new UntypedFormControl(!this.isBackup)
    });
    // }
    // SET UP YEAR RANGE FOR CREDIT CARD EXPIRATION DATE FIELD
    for (let i: number = 0; i < 15; i++) {
      this.YearRange.push(this.Year + i);
    }

    this.isMember = this.gb.MemberType == MemberTypes.Member;

    this.onFormChanged = new EventEmitter();

    let disposable = this.form.valueChanges.subscribe(response => {
      //console.log(this.ccNumber.nativeElement.className);
      this.CheckCredtiCardType(response.creditCard);
      this.onFormChanged.emit(response);

      //console.log(response);
    });
  }

  CheckCredtiCardType(value: string) {

    console.log("Credit Card Value : " + value);
    let cardType: CreditCardTypes = CreditCardHelper.GetCardTypes(value);
    this.ccardType = cardType;
    let newCardType: string = cardType.toString().toLowerCase();

    // this.ccardTypeClass = newCardType;

  }

  isValidExpiration() {

    let ccExpMonth = this.getExpDateMonth(this.form.controls.expMonth.value);
    let ccExpYear = this.getExpDateYear(this.form.controls.expYear.value);

    if (moment(ccExpMonth + '/' + ccExpYear, 'MM/YYYY').isSameOrAfter(moment(moment().format('MM/YYYY'), 'MM/YYYY'))) {
      return true;
    } else {
      return false;
    }
  }

  getExpDateMonth(month: string): string {

    try {

      // let month = expDate.split('/')[0].trim();
      if (month.length == 1)
        return '0' + month;
      else
        return month;

    } catch (e) {
      return '0';
    }
  }

  getExpDateYear(year: string): string {

    try {

      // let year = expDate.split('/')[1].trim();
      if (year.length == 2)
        return '20' + year;
      else
        return year;

    } catch (e) {
      return '0';
    }
  }

  SubmitNewCreditCard(form: UntypedFormGroup) {
    // check form is valid
    if (!this.form.valid)
      return;

    // check card is valid
    let ccard = this.form.controls.creditCard;
    if (!ccard.valid)
      return;

    // extract expiration month and year
    let expMonth = this.getExpDateMonth(this.form.controls.expMonth.value);
    let expYear = this.getExpDateYear(this.form.controls.expYear.value);

    if (!this.isValidExpiration())
    {
      // show confirmation
      Swal.fire({
        title: "Validation Error",
        text: "The expiration date is invalid.",
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: true,
      }).then(() => { }, () => { }); // keep this line to prevent promise error;

      return; // error
    }

    // get credit card type
    let card = CreditCard.cardFromNumber(ccard.value);

    // get other data
    let setAsDefault = this.form.controls.setAsDefault.value;


    // put date in request
    let newCard = new AddCreditCardRequest();


    // newCard.Address01 = ccardForm.controls.address1.value;
    // newCard.City = ccardForm.controls.city.value;
    // newCard.State = ccardForm.controls.state.value;
    // newCard.Country = ccardForm.controls.country.value;
    // newCard.ZipCode = ccardForm.controls.zip.value;

    newCard.CreditCardNumber = this.form.controls.creditCard.value;
    newCard.CVV = Number.parseInt(this.form.controls.cvc.value);
    newCard.ExpMonth = Number.parseInt(expMonth);
    newCard.ExpYear = Number.parseInt(expYear);

    newCard.CardType = CreditCardResponse.GetCreditCardTypeFromString(card.type);

    newCard.SetAsDefault = (setAsDefault == null) ? false : setAsDefault;
    newCard.FirstName = this.form.controls.firstName.value;
    newCard.LastName = this.form.controls.lastName.value;
    newCard.ZipCode = this.form.controls.zipCode.value;

    console.log("New Request:", newCard);

    //if( 0==0 ) return;

    this.AddCreditCard(newCard).then(() => {
      // reset form

      

     
    });
  }

  ResetForm() {
    this.form.controls.creditCard.setValue('');
    this.form.controls.expMonth.setValue(this.gb.ThisMonth());
    this.form.controls.expYear.setValue(new Date().getFullYear());
    this.form.controls.cvc.setValue('');

    this.form.controls.firstName.setValue('');
    this.form.controls.lastName.setValue('');

    this.form.markAsPristine();
    this.form.markAsUntouched();

    this.emitClose.emit();
  }




  AddCreditCard(newCard: AddCreditCardRequest): Promise<any> {

    this.IsBusy = true;

    return this.api.CreditCardAdd(newCard).toPromise()
      .then(
        response => {
          this.IsBusy = false;

          console.log("Credit Card Add Response", response);

          if (!response.Result)
          {
            var title = "Error";
            if (response.Message.toLowerCase().includes("zip"))
              title = "Zip Code Mismatch";
            else if (response.Message.toLowerCase().includes("cvc"))
              title = "Card Verification";
            else if (response.Message.toLowerCase().includes("contact your bank"))
              title = "Card Not Added";

            // show confirmation
            Swal.fire({
              title: title,
              text: response.Message,
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: true,
            }).then(() => { }, () => { }); // keep this line to prevent promise error;
            
            return; // error
          }

          // switch tabs
          this.RefreshCards();

          // show confirmation
          Swal.fire({
            title: 'Saved!',
            text: 'New Credit Card Saved.',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.ResetForm();
            this.emitClose.emit();
          }, () => { }); // keep this line to prevent promise error;

        },
      )
      .catch((error: any) => {
        this.IsBusy = false;
      }
      );


  }

  RefreshCards(): void {

    // this.IsBusy = true;

    // let request = this.api.CreditCardGetAll()
    //     .subscribe(response => {
    //         request.unsubscribe();

    //         this.IsBusy = false;

    //         if (!response.Result)
    //             return; // error

    //         if (response.Data.length == 0)
    //             return;

    //         this.Cards = response.Data;

    //         // find default card
    //         let index = this.Cards.findIndex(x => x.IsDefault == true);

    //         // set default card
    //         this.DefaultCard = this.Cards[index];

    //         // remove default card from list
    //         this.Cards.splice(index, 1);

    //     },


    //         (error: HttpError) => {
    //             request.unsubscribe();
    //             this.IsBusy = false;
    //         }
    //     );


  }

}
